import { combineReducers } from 'redux';

import { REDUCER_NAME as SHIPMENT_REDUCER_NAME } from 'domain/shipment/view/constants';
import { REDUCER_NAME as TRACKING_REDUCER_NAME } from 'domain/shipment/tracking/constants';
import { REDUCER_NAME as BOOK_REDUCER_NAME } from 'domain/shipment/book/constants';
import { REDUCER_NAME as PDF_REDUCER_NAME } from 'domain/shipment/pdf/constants';
import { REDUCER_NAME as REPORT_REDUCER_NAME } from 'domain/shipment/report/constants';
import { REDUCER_NAME as NEW_ORDER_REDUCER_NAME } from 'domain/shipment/newOrder/constants';
import { REDUCER_NAME as BATCH_ORDERS_REDUCER_NAME } from 'domain/shipment/batchOrders/constants';
import { REDUCER_NAME as FACTORY_UPLOAD_REDUCER_NAME } from 'domain/shipment/factoryUpload/constants';
import shipmentReducer from 'domain/shipment/view/reducer';
import bookReducer from 'domain/shipment/book/reducer';
import pdfReducer from 'domain/shipment/pdf/reducer';
import reportReducer from 'domain/shipment/report/reducer';
import newOrderReducer from 'domain/shipment/newOrder/reducer';
import FactoryUploadReducer from 'domain/shipment/factoryUpload/reducer';

import batchOrdersReducer from 'domain/shipment/batchOrders/reducer';
import orderReducer from 'domain/shipment/order/reducer';
import { REDUCER_NAME as ORDER_REDUCER_NAME } from 'domain/shipment/order/constants';
import { REDUCER_NAME } from 'domain/shipment/constants';
import actionTypes from 'domain/shipment/actionTypes';

const initialState = {
  data: [],
  isFetching: true,
  isBatchingOrders: false,
  isGeneratingReport: false,
  isBatchingScreenOpened: false,
  isBatchedSuccessfully: false,
  batchedSalesOrders: [],
};

const shipmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isFetching: true,
        data: [],
      };

    case actionTypes.FETCHING:
      return {
        ...state,
        isFetching: true,
        data: [],
      };

    case actionTypes.FETCHED:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };

    case actionTypes.BATCH_SALES_ORDERS:
      return {
        ...state,
        isBatchingOrders: true,
      };
    case actionTypes.BATCHED_SALES_ORDERS:
      return {
        ...state,
        batchedSalesOrders: action.payload.data,
        isBatchingOrders: false,
      };

    case actionTypes.GENERATE_REPORT:
      return {
        ...state,
        isGeneratingReport: true,
      };

    case actionTypes.GENERATED_REPORT:
      return {
        ...state,
        isGeneratingReport: false,
      };

    case actionTypes.TOGGLE_BATCHING_SCREEN:
      return {
        ...state,
        isBatchingScreenOpened: !state.isBatchingScreenOpened,
      };

    case actionTypes.BATCHED_SUCCESSFULLY:
      return {
        ...state,
        isBatchedSuccessfully: !state.isBatchedSuccessfully,
      };

    default:
      return state;
  }
};

export default combineReducers({
  [REDUCER_NAME]: shipmentsReducer,
  [SHIPMENT_REDUCER_NAME]: shipmentReducer,
  [BOOK_REDUCER_NAME]: bookReducer,
  [PDF_REDUCER_NAME]: pdfReducer,
  [ORDER_REDUCER_NAME]: orderReducer,
  [REPORT_REDUCER_NAME]: reportReducer,
  [NEW_ORDER_REDUCER_NAME]: newOrderReducer,
  [BATCH_ORDERS_REDUCER_NAME]: batchOrdersReducer,
  [FACTORY_UPLOAD_REDUCER_NAME]: FactoryUploadReducer,
});
